module.exports = __webpack_public_path__ + "static/media/guest_icon.94caf1f1.png";